import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(({
  typography,
  palette,
  spacing
}) => ({
  root: {
    position: 'relative'
  },
  textFieldRoot: {
    borderBottom: `1px solid ${palette.grey[200]}`,
    '& input': {
      fontSize: typography.body2.fontSize,
      paddingTop: spacing(2.5),
      paddingBottom: spacing(2.5),
      paddingLeft: spacing(6.5),
      paddingRight: spacing(3),
      overflow: 'hidden !important',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      '&[placeholder]': {
        overflow: 'hidden',
        textOverflow: 'ellipsis !important',
        whiteSpace: 'nowrap'
      },
      '&::placeholder': {
        overflow: 'hidden',
        textOverflow: 'ellipsis !important',
        whiteSpace: 'nowrap'
      }
    },
    '& > div:after': {
      display: 'none'
    },
    '& > div:before': {
      display: 'none'
    }
  },
  iconRoot: {
    position: 'absolute',
    left: spacing(2),
    top: spacing(1.75),
    color: palette.secondary.main
  },
  iconButtonRoot: {
    marginRight: spacing(1.5)
  }
}));